<div #card="tuiActiveZone" (tuiActiveZoneChange)="onZoneChange($event)">
  <div class="flex gap-x-2 mb-2">
    <app-autocomplete
      tuiDropdownContext
      #clientJsonDropdown="tuiDropdown"
      [tuiDropdown]="clientJsonContext"
      class="w-2/12"
      [formControl]="preOrderForm.controls.clientJson.controls.id"
      [items]="catalogs.clients$ | async"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      label="Мой клиент"
      [labelOutside]="false"
      (valueChanged)="onClientChange()"
    ></app-autocomplete>
    <ng-template #clientJsonContext>
      <tui-data-list role="menu" tuiDataListDropdownManager>
        <button
          (click)="
            openClientDialog$.next('create'); clientJsonDropdown.toggle(false)
          "
          tuiOption
        >
          Добавить клиента
        </button>
        <button
          [disabled]="!preOrderForm.controls.clientJson.controls.id.value"
          (click)="
            openClientDialog$.next('edit'); clientJsonDropdown.toggle(false)
          "
          tuiOption
        >
          Редактировать клиента
        </button>
      </tui-data-list>
    </ng-template>
    <app-autocomplete
      class="w-2/12"
      label="Адрес"
      [labelOutside]="false"
      [formControl]="
        preOrderForm.controls.clientAddressWithCoordinatesJson.controls.address
      "
      [items]="availableAddresses$ | async"
      [itemText]="'address'"
      [itemValue]="'address'"
      (valueChanged)="onAddressChange()"
      tuiTextfieldSize="m"
      >Адрес</app-autocomplete
    >
    <app-autocomplete
      class="w-2/12"
      tuiDropdownContext
      #farmJsonDropdown="tuiDropdown"
      [tuiDropdown]="farmJsonContext"
      [formControl]="preOrderForm.controls.farmJson.controls.id"
      [items]="catalogs.farms$ | async"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      label="Питомник"
      [labelOutside]="false"
      [hintContent]="
        farmJson.controls.taxNonPayer.getRawValue() ? 'Неплательщик НДС' : ''
      "
      (valueChanged)="onFarmChange()"
    ></app-autocomplete>
    <ng-template #farmJsonContext>
      <tui-data-list role="menu" tuiDataListDropdownManager>
        <button
          (click)="
            openFarmDialog$.next('create'); farmJsonDropdown.toggle(false)
          "
          tuiOption
        >
          Добавить питомник
        </button>
        <button
          [disabled]="!preOrderForm.controls.farmJson.controls.id.value"
          (click)="openFarmDialog$.next('edit'); farmJsonDropdown.toggle(false)"
          tuiOption
        >
          Редактировать питомник
        </button>
      </tui-data-list>
    </ng-template>
    <app-autocomplete
      class="w-2/12"
      [formControl]="preOrderForm.controls.farmAddress.controls.address"
      [items]="availableFarmAddresses$ | async"
      [itemText]="'address'"
      [itemValue]="'address'"
      [displayValue]="'address'"
      [itemSearch]="'address'"
      label="Адрес"
      [labelOutside]="false"
      (valueChanged)="onFarmAddressChange($event)"
    ></app-autocomplete>
    <app-autocomplete
      class="w-2/12"
      [formControl]="preOrderForm.controls.flowerType"
      [items]="availableFlowerTypes$ | async"
      [itemSearch]="'search'"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      label="Группа товаров"
      [labelOutside]="false"
    ></app-autocomplete>

    <div class="w-1/12 flex items-center">
      <tui-toggle
        [formControl]="preOrderForm.controls.imported"
        size="m"
        class="mx-2"
      ></tui-toggle>
      <span class="text-sm">Импорт</span>
    </div>
    <div class="w-1/12 flex items-center">
      <app-checkbox [formControl]="preOrderForm.controls.cold"></app-checkbox>
      <span class="px-2">Холод</span>
    </div>
  </div>
  <div class="flex gap-x-2 mb-2" *tuiLet="isImport$ | async as isImport">
    <div
      class="w-2/12"
      tuiDropdownContext
      #buyerCodeDropdown="tuiDropdown"
      [tuiDropdown]="buyerCodeContext"
    >
      <app-autocomplete
        label="Код покупателя"
        [strict]="false"
        [labelOutside]="false"
        [formControl]="preOrderForm.controls.buyerCode"
        [items]="buyersOfSelectedFarm$ | async"
        [itemSearch]="'search'"
        [itemValue]="'code'"
        [displayValue]="'code'"
        [itemText]="'code'"
      ></app-autocomplete>
      <ng-template #buyerCodeContext>
        <tui-data-list role="menu" tuiDataListDropdownManager>
          <button
            (click)="
              openCreateBuyerDialog$.next(); buyerCodeDropdown.toggle(false)
            "
            tuiOption
          >
            Добавить покупателя в каталог
          </button>
        </tui-data-list>
      </ng-template>
    </div>

    @if (isImport) {
      <div class="flex gap-x-2 w-3/12">
        <app-autocomplete
          class="w-3/12"
          [items]="countries()"
          [itemText]="'name'"
          [itemValue]="'letterCode'"
          [itemSearch]="'search'"
          [formControl]="preOrderForm.controls.countryLetter"
        ></app-autocomplete>
        <tui-input
          class="w-4/12"
          [formControl]="preOrderForm.controls.airWaybillNumber"
          tuiTextfieldSize="m"
          >AWB</tui-input
        >
        <div class="w-1/12 mt-2.5">
          <app-checkbox
            [formControl]="preOrderForm.controls.precooling"
            [tuiHint]="precooling"
          ></app-checkbox>
          <ng-template #precooling> Pre-cooling </ng-template>
        </div>

        <tui-input-number
          class="w-4/12"
          tuiTextfieldSize="m"
          [formControl]="preOrderForm.controls.weight"
          >Вес</tui-input-number
        >
      </div>
    }
    <div [class]="isImport ? 'w-7/12' : 'w-10/12'">
      <app-cargo-place-details
        *ngFor="
          let details of preOrderForm.controls.cargoPlacesJson.controls;
          let index = index;
          let last = last
        "
        (create)="addCargoPlaceDetails()"
        (remove)="removeCargoPlaceDetails(index)"
        [isImport]="(isImport$ | async)!"
        [last]="last"
        [cargoPlaceDetailsForm]="details"
      ></app-cargo-place-details>
      @if (!preOrderForm.controls.cargoPlacesJson.controls.length) {
        <button
          (click)="addCargoPlaceDetails()"
          class="mt-1.5"
          size="s"
          icon="tuiIconPlus"
          tuiButton
        >
          Добавить грузовое место
        </button>
      }
    </div>
  </div>
  <div class="flex gap-x-2">
    <app-autocomplete
      class="w-2/12"
      [formControl]="preOrderForm.controls.farmBrokerJson.controls.id"
      [items]="catalogs.brokerFarms$ | async"
      [itemText]="'name'"
      [itemValue]="'id'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      label="Питомник посредник"
      [labelOutside]="false"
      (valueChanged)="onFarmBrokerChange()"
    ></app-autocomplete>
    <app-autocomplete
      label="Посредник"
      [labelOutside]="false"
      class="w-2/12"
      [formControl]="preOrderForm.controls.brokerJson.controls.id"
      [items]="sellers$ | async"
      [itemValue]="'id'"
      [itemText]="'name'"
      [displayValue]="'name'"
      [itemSearch]="'search'"
      (valueChanged)="fillBrokerJson($event)"
    >
    </app-autocomplete>
    <div class="w-[140px] flex items-center">
      <tui-toggle
        [formControl]="preOrderForm.controls.prepayment"
        size="m"
        class="mx-2"
      ></tui-toggle>
      <span class="text-sm">Предоплата</span>
    </div>
    <tui-input-number
      class="w-1/12"
      [precision]="2"
      [formControl]="preOrderForm.controls.prepaymentSum"
      tuiTextfieldSize="m"
      >Сумма</tui-input-number
    >
    <app-autocomplete
      class="w-1/12"
      label="Валюта"
      [labelOutside]="false"
      [itemValue]="'letterCode'"
      [itemText]="'name'"
      [items]="CURRENCIES"
      [formControl]="preOrderForm.controls.prepaymentCurrencyLetter"
    ></app-autocomplete>
    <div class="w-[140px]">
      <app-input-date
        [formControl]="preOrderForm.controls.paymentDate"
        label="Дата платежа"
        [labelOutside]="false"
      ></app-input-date>
    </div>
    <div class="w-[140px]">
      <app-input-date
        [labelOutside]="false"
        [formControl]="preOrderForm.controls.expectedLoadingDate"
        label="Дата загрузки (оритент.)"
      ></app-input-date>
    </div>
  </div>
</div>
